import { Markup } from 'interweave';
import { IMenu } from './MenuItem';

export const SecondaryMenuItem = ({ icon, name, devider, selected, onClick }: IMenu) => {
  const handleClick = () => {
    onClick && onClick();
  };

  return (
    <>
      <div
        className={`group relative flex items-center px-4 leading-7 text-sm cursor-pointer ${
          selected ? 'bg-blue-menu-active' : 'hover:bg-[#efefef]'
        }`}
        role="menuitem"
        tabIndex={-1}
        onClick={handleClick}
      >
        {icon}
        <span
          className={`font-lato font-normal leading-4 py-2 break-all w-full ${selected ? 'text-white' : 'text-black'}`}
        >
          <Markup content={name} />
        </span>
      </div>
      {devider && <div className="my-2 border-b border-gray-popup" />}
    </>
  );
};
